<div id="carouselIndicators" data-ride="carousel" class="carousel slide carousel-fade">
    <ol class="carousel-indicators">
        <li data-target="#carouselIndicators" data-slide-to="0" class="active"></li>
        <li data-target="#carouselIndicators" data-slide-to="1"></li>
    </ol>
    <div class="carousel-inner">
        <div class="carousel-item active"><img src="/assets/images/sp1.jpg" alt="..." class="d-block w-100"></div>
        <div class="carousel-item"><img src="/assets/images/sp2.jpg" alt="..." class="d-block w-100"></div>
    </div><a href="#carouselExampleIndicators" role="button" data-slide="prev" class="carousel-control-prev" style="display: none;"><span  aria-hidden="true" class="carousel-control-prev-icon"></span><span  class="sr-only">Previous</span></a>
    <a href="#carouselExampleIndicators" role="button" data-slide="next" class="carousel-control-next" style="display: none;"><span  aria-hidden="true" class="carousel-control-next-icon"></span><span  class="sr-only">Next</span></a>
</div>
<div class="container mt-5">
    <ul id="pills-tab" role="tablist" class="nav nav-pills row justify-content-left classification pl-0 mb-4">
        <li class="nav-item col-2 col-sm-2 col-md-2 col-lg-2 mb-3">
            <a class="nav-link mgl fgq f18 mx-auto" [ngClass]="{'active': na === 0}" (click)="nActive(0, 0)">ᠪᠥᠬᠥ ᠨᠣᠮ</a>
        </li>
        <li class="nav-item col-2 col-sm-2 col-md-2 col-lg-2 mb-3" *ngFor="let nl of navList;let i = index">
            <a class="nav-link mgl fgq f18 mx-auto" [ngClass]="{'active': na === i + 1}" (click)="nActive(i + 1, nl.taxonomyId)">{{nl.taxonomyTitle}}</a>
        </li>
    </ul>
    <div id="pills-tabContent" class="tab-content">
        <div id="cat-1" role="tabpanel" aria-labelledby="cat-1-tab" class="tab-pane fade show active">
            <div class="row">
                <div class="col-6 col-sm-6 col-md-4 col-xl-2dot4 book media position-relative pl-0 mb-5" *ngFor="let bl of bookList">
                    <img alt="" class="shadow mr-3" style="height: 100%;" src="{{url + bl.bookImage}}">
                    <div class="media-body mgl">
                        <h5 class="m-0 fgq f18">{{bl.title}}</h5>
                        <a class="stretched-link" href="book/{{bl.bookId}}"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <nav aria-label="Page navigation example">
        <ul class="pagination justify-content-center">
            <nz-pagination [(nzPageIndex)]="page" [nzPageSize]="pageSize" [nzTotal]="total" (nzPageIndexChange)="GetBookList(navId, page, pageSize)" nzSimple></nz-pagination>
        </ul>
    </nav>
    <!-- <app-page [total]="total" [page]="page" [pageSize]="pageSize" (page)="GetBookList(navId, $event, pageSize)"></app-page> -->
</div>